<script>
    import Qr from './Qr.svelte'
    import {
        soreThroat,
        bodyPains,
        headache,
        fever,
        covidContact,
        supsectContact,
        travelAbroad,
        travelCity,
        feverDetected
    } from '../store.js'

    let checkup = false
    let qr = false
    if (
        $soreThroat === 'YES' ||
        $bodyPains === 'YES' ||
        $headache === 'YES' ||
        $fever === 'YES' ||
        $covidContact === 'YES' ||
        $supsectContact === 'YES' ||
        $travelAbroad === 'YES' ||
        $travelCity !== 'NO' ||
        $feverDetected === 'true'
    ) {
        checkup = true
    } else {
        qr = true
    }

    let tos_url = "https://drive.google.com/open?id=16ctFTh6ggV9NkaMRc_idSWUXyIFyC5nZ";
    let pp_url = "https://drive.google.com/open?id=16bx1eM8n1Eyyb06Sd4JLRl_FywQxi1ol";
</script>

<main>
    {#if checkup === true}
    <div class="body">
        <div class="content">
            <h1>Please proceed to a symptom checkup</h1>
            <a class="btn btn-primary" href="/assessor">Continue</a>
        </div>
        <div class="content">
            <img src="img/who.svg" class="source_logo">
            <img src="img/cdc.svg" class="source_logo">
            <h3>Based on reliable sources</h3>
            <p>This tool is constantly updated based on official information from the WHO and the latest CDC guidelines.</p>
        </div>
        <div class="content">
            <a href="{tos_url}" target="_blank">Terms of Service</a> | <a href="{pp_url}" target="_blank">Privacy Policy</a>
        </div>
    </div>
    {/if}

    {#if qr === true}
    <Qr/>
    {/if}
</main>

<style>
    .source_logo {
        max-width: 120px;
        max-height: 100px;
        margin-right: 16px;
    }
</style>